import GeometryAlgorithm from '../../geometry/GeometryAlgorithm';
import CheckResult from './CheckResult';

/**
 * 检查规则基类,所有检查规则都从此类派生
 */
export default class CheckRule {
    /**
     * 初始化方法
     */
    constructor() {
        /**
         * 错误等级
         * @type {Number}
         */
        this.level = 1; // 错误等级：1.错误；2.警告；3.确认；
        /**
         * 检查规则描述
         * @type {string}
         */
        this.description = '';

        this.geometryAlgorithm = GeometryAlgorithm.getInstance();
    }

    /**
     * 添加到控制器中
     * @param {Object}  controller CheckController对象
     */
    addTo(controller) {
        if (controller) {
            controller.add(this);

            return this;
        }
        return null;
    }

    /**
     * 删除
     */
    remove() {
        return this.removeFrom(this._controller);
    }

    /**
     * 从控制器中删除
     * @param {object} controller 控制器对象
     */
    removeFrom(controller) {
        if (controller) {
            controller.delete(this);

            return this;
        }
        return null;
    }

    /**
     * 添加到控制器时调用，执行初始化操作
     * @param {object} controller 控制器实例
     */
    onAdd(controller) {
        this._controller = controller;
        this.featureSelector = controller.featureSelector;
    }

    /**
     * 从控制器中删除时调用，执行数据清理
     */
    onRemove() {
        this._controller = null;
        this.featureSelector = null;
    }

    /**
     * 子类需要重写此方法
     * @param  {object} editResult 待检查的编辑结果
     * @return {array} 检查结果数组
     */
    check(editResult) {
        const results = [];
        results.push(this.checkResult());

        return results;
    }

    /**
     * 生成检查结果
     * @param {string} message 检查结果信息
     * @param {number} level   检查结果等级
     */
    checkResult(message = this.description, level = this.level) {
        return new CheckResult(this, message, level);
    }
}
